import { useCopyValue } from '@hooks'

const DashboardLink = ({ url }: { url: string }) => {
  const { nodeRef, copyOnClick, copySuccess } = useCopyValue()
  const openDashboard = () => window.open(url, '_blank')

  return (
    <div className='box marginTop'>
      <div className='flex-1'>URL Dashboard</div>
      <div className='flex-2 data'>
        <div className='flex'>
          <div className='flex-1' onClick={openDashboard}>
            <textarea ref={nodeRef} value={url} readOnly className='text-copy' />
            <div className='url'>{url}</div>
          </div>
          <div className='copy' onClick={copyOnClick}>
            {copySuccess && <div className='text-success'>Copy success</div>}
            Copy
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardLink
